/* Loaded only for signed-out visitors (see theme.liquid). Judge.me's
   "Everyone" mode shows the write-review controls to guests; this gate
   sends them to sign in first, matching the previous review app.
   Customer accounts keep their session on shopify.com, so Liquid renders
   this page as signed-out even for logged-in customers; the analytics
   customer id is the only reliable signal, checked at click time. */
(function () {
  var TRIGGERS = [
    '[class*="write-review"]',
    '.jdgm-write-rev-link',
    '.jm-action-buttons__button',
    '.jm-no-reviews-state .jm-star-rating'
  ].join(', ');
  function signedIn() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return Boolean(
      (meta && meta.page && meta.page.customerId) ||
        (window.__st && window.__st.cid)
    );
  }
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(TRIGGERS);
      if (!trigger || !trigger.closest('[class*="jdgm"], [class*="jm-"]')) return;
      if (signedIn()) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.href =
        '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
    },
    true
  );
})();
